import React from 'react';
import { Form } from 'semantic-ui-react';
import i18n from 'i18next';

import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { getIn } from "formik";
import { translationSuffixes } from '../../constants';
import TooltipWrapper from '../TooltipWrapper';
import AdvancedFieldError from "../FieldError/index2";

class InputWithLabelWrapper extends React.Component {
  getFullLabel = errorMessages => {
    const {
      label,
      tooltip,
      specialRequiredCondition,
      labelClassName,
      tooltipClassName
    } = this.props;

    const translatedLabel = (
      <label className={labelClassName}>
        <TooltipWrapper label={label} tooltip={tooltip} tooltipClassName={tooltipClassName} />
        {this.getTranslatedLabel()}{' '}
        {label && this.isRequiredField(specialRequiredCondition) && <strong>*</strong>}
      </label>
    );

    return (
      <>
        {translatedLabel}
        <AdvancedFieldError messages={errorMessages} />
      </>
    );
  };

  getTranslatedLabel = () => {
    const { label, t } = this.props;
    if (label && i18n.exists(label)) {
      return t(label);
    } else if (i18n.exists(label + translationSuffixes.label)) {
      return t(label + translationSuffixes.label);
    } else {
      return label;
    }
  };

  isRequiredField = specialRequiredCondition => {
    const { requiredFields, name } = this.props;
    return (requiredFields && requiredFields.includes(name)) || specialRequiredCondition;
  };

  render() {
    const {
      errors,
      name,
      render,
      fieldClassName,
      displayOnlyFirstLevelErrors,
      displayPropertyErrors,
      displayLabelAfter,
      ...restProps
    } = this.props;
    let errorMessages = getIn(errors, name);
    errorMessages = getIn(errorMessages, displayPropertyErrors);
    if (displayOnlyFirstLevelErrors && typeof errorMessages !== 'string') errorMessages = null;

    return (
      <Form.Field error={errorMessages != null} className={fieldClassName}>
        {!displayLabelAfter && this.getFullLabel(errorMessages)}
        {displayLabelAfter && <AdvancedFieldError messages={errorMessages} />}
        {render && render({ ...restProps, name })}
        {displayLabelAfter && this.getFullLabel()}
      </Form.Field>
    );
  }
}

InputWithLabelWrapper.propTypes = {
  label: PropTypes.string.isRequired,
  errors: PropTypes.object,
  name: PropTypes.string,
  render: PropTypes.func,
  specialRequiredCondition: PropTypes.bool.isRequired
};

InputWithLabelWrapper.defaultProps = {
  specialRequiredCondition: false,
  label: '',
  displayLabelAfter: false
};
export default withTranslation()(InputWithLabelWrapper);
